import React from 'react';
import { TextInput, required, SelectInput, ReferenceInput } from 'react-admin';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';

const UnitForm = ({
  nameLabel,
  statusLabel,
  status,
  courseLabel,
  scormLabel,
}) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={12} md={6}>
      <TextInput
        source="name"
        label={nameLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={6}>
      <SelectInput
        source="status"
        defaultValue={status[0].id}
        choices={status}
        label={statusLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={6}>
      <ReferenceInput
        label={courseLabel}
        source="courseId.id"
        reference="courses"
        perPage={90000}
      >
        <SelectInput fullWidth optionText="name" />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} sm={12} md={6}>
      <ReferenceInput
        perPage={90000}
        label={scormLabel}
        source="scorms.id"
        reference="scorms"
      >
        <SelectInput fullWidth optionText="fileName" />
      </ReferenceInput>
    </Grid>
  </Grid>
);

UnitForm.propTypes = {
  nameLabel: PropTypes.string.isRequired,
  statusLabel: PropTypes.string.isRequired,
  status: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  courseLabel: PropTypes.string.isRequired,
  scormLabel: PropTypes.string.isRequired,
};

export default UnitForm;
